(function() {
  'use strict';

  const FAQCategoryDetail = {
    init: function(sectionId) {
      this.section = document.querySelector(`[data-section-id="${sectionId}"]`);
      if (!this.section) return;

      this.bindEvents();
      this.checkDeepLink();
    },

    bindEvents: function() {
      const toggleButtons = this.section.querySelectorAll('[data-faq-toggle]');
      
      toggleButtons.forEach(button => {
        button.addEventListener('click', (e) => {
          this.toggleAccordion(button);
        });
      });
    },

    toggleAccordion: function(button) {
      const isExpanded = button.getAttribute('aria-expanded') === 'true';
      const answerId = button.getAttribute('aria-controls');
      const answerWrapper = document.getElementById(answerId);

      if (!answerWrapper) return;

      if (isExpanded) {
        // Collapse
        this.collapseItem(button, answerWrapper);
      } else {
        // Expand
        this.expandItem(button, answerWrapper);
      }
    },

    expandItem: function(button, answerWrapper) {
      button.setAttribute('aria-expanded', 'true');
      answerWrapper.removeAttribute('hidden');
      
      // Set height for animation
      const answer = answerWrapper.querySelector('.faq-answer');
      const height = answer.scrollHeight;
      answerWrapper.style.height = height + 'px';

      // Remove height after animation
      setTimeout(() => {
        answerWrapper.style.height = 'auto';
      }, 300);
    },

    collapseItem: function(button, answerWrapper) {
      const answer = answerWrapper.querySelector('.faq-answer');
      const height = answer.scrollHeight;
      
      // Set explicit height before collapsing
      answerWrapper.style.height = height + 'px';
      
      // Force reflow
      answerWrapper.offsetHeight;
      
      // Collapse
      answerWrapper.style.height = '0';
      
      setTimeout(() => {
        button.setAttribute('aria-expanded', 'false');
        answerWrapper.setAttribute('hidden', '');
      }, 300);
    },

    checkDeepLink: function() {
      // Check if there's a hash in the URL pointing to an FAQ item
      const hash = window.location.hash;
      if (hash && hash.startsWith('#faq-')) {
        const faqItem = this.section.querySelector(hash);
        if (faqItem) {
          const button = faqItem.querySelector('[data-faq-toggle]');
          if (button) {
            // Open the accordion
            setTimeout(() => {
              const answerId = button.getAttribute('aria-controls');
              const answerWrapper = document.getElementById(answerId);
              if (answerWrapper) {
                this.expandItem(button, answerWrapper);
                // Scroll to item
                faqItem.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }, 100);
          }
        }
      }
    }
  };

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', function() {
    const faqSection = document.querySelector('[data-section-type="faq-category-detail"]');
    if (faqSection) {
      const sectionId = faqSection.dataset.sectionId;
      FAQCategoryDetail.init(sectionId);
    }
  });

  // Re-initialize on Shopify theme editor section load
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      const section = event.target.querySelector('[data-section-type="faq-category-detail"]');
      if (section) {
        const sectionId = section.dataset.sectionId;
        FAQCategoryDetail.init(sectionId);
      }
    });
  }
})();
